// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1931":"f869309c6cffa6a8","2443":"f869309c6cffa6a8","3185":"f1aa587d7780911d"}[chunkId] + ".css";
};